import {
	COLLECTION_ITEM_SUBTYPE_MENU,
	COLLECTION_ITEM_SUBTYPE_PANORAMA,
	COLLECTION_ITEM_SUBTYPE_STORY,
	COLLECTION_ITEM_SUBTYPE_WEB,
} from 'mytours-read-common'

export const getPlaceholderTypeByPathname = (pathname: string) => {
	if (pathname.includes(COLLECTION_ITEM_SUBTYPE_WEB)) return COLLECTION_ITEM_SUBTYPE_WEB
	else if (pathname.includes(COLLECTION_ITEM_SUBTYPE_MENU)) return COLLECTION_ITEM_SUBTYPE_MENU
	else if (pathname.includes(COLLECTION_ITEM_SUBTYPE_PANORAMA)) return COLLECTION_ITEM_SUBTYPE_PANORAMA
	else return COLLECTION_ITEM_SUBTYPE_STORY
}
